import React from "react";
import "../../css/tp-sect2.css";
import StartIll from "../../assets/images/teacherPage-sect2-img.png";

const Sect2 = ()=> {
    return (
        <section id="tp-sect2">
            <div>
                <img src={StartIll} alt="" />
                <article>
                    <h2>Start teaching in 4 easty steps</h2>
                    <div>
                        <div>
                            <span>1</span>
                            <h3>Create account</h3>
                            <p>
                                Get a complete sales dashboard in the cloud. 
                                See activity, revenue and social metrics all in one place.
                            </p>
                        </div>
                        <div>
                            <span>2</span>
                            <h3>Upload your course</h3>
                            <p>
                                Our calendar lets you know what is happening with 
                                customer and projects so you are able to control process.
                            </p>
                        </div>
                        <div>
                            <span>3</span>
                            <h3>Get reviewed by experts</h3>
                            <p>
                                End to End Business Platform, Sales Management, 
                                Marketing Automation, Help Desk and many more
                            </p>
                        </div>
                        <div>
                            <span>4</span>
                            <h3>Start selling your course</h3>
                            <p>
                                A tool that lets you build a dream website even 
                                if you know nothing about web design or programming.
                            </p>
                        </div>
                    </div>
                </article>
            </div>
        </section>
    )
}

export default Sect2;